import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Layout.css';
import HomeHeader from '../Header/HomeHeader';
import Feedback from '../Feedback';
import Footer from '../Footer';
import CookiesDisclaimer from '../CookiesDisclaimer';

const HomeLayout = ({ layoutType, children }) => {

  return (
    <>
      <HomeHeader borderLess={true} layoutType={layoutType} />
      {children}
      <Feedback />
      <Footer />
      <CookiesDisclaimer />
    </>
  );
}
HomeLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withStyles(s)(HomeLayout);